<template>
  <div class="program">
    <div class="v2-container-small">
      <h2 class="program__title">
        {{ title }}
      </h2>

      <div class="program__about">
        <div class="program__about--item">
          <img
            src="/v2/ege/program/quantity.svg"
            alt="quantity"
          >
          <span>{{ quantity }}</span>
        </div>

        <div class="program__about--item">
          <img
            src="/v2/ege/program/time.svg"
            alt="time"
          >
          <span>{{ minutes }}</span>
        </div>

        <div class="program__about--item">
          <img
            src="/v2/ege/program/year.svg"
            alt="year"
          >
          <span>программа 2024 года</span>
        </div>

        <div class="program__about--item">
          <img
            src="/v2/ege/program/schedule.svg"
            alt="schedule"
          >
          <span>{{ schedule }}</span>
        </div>
      </div>

      <div class="program__list program">
        <div
          v-for="(module, idx) of modules"
          :key="`module${idx + 1}`"
          class="program__module"
          @click="toggleTab(idx)"
        >
          <div class="program__module--icon">
            <img
              v-if="!activeTabs.includes(idx)"
              src="/v2/ege/program/plus.svg"
              alt="plus"
            >
            <img
              v-else
              src="/v2/ege/program/minus.svg"
              alt="minus"
            >
          </div>

          <p class="program__module--quantity">
            {{ module.lessons.length }} занятия
          </p>

          <h6 class="program__module--name">
            {{ module.name }}
          </h6>

          <ul
            :class="[
              'program__module--list',
              `program__module--list--${idx}`,
              { 'active': activeTabs.includes(idx) },
            ]"
            :style="{
              height: !activeTabs.includes(idx) ? 0 : getHeight(idx),
              'margin-top': !activeTabs.includes(idx) ? 0 : '20px',
            }"
          >
            <li
              v-for="(item, index) of module.lessons"
              :key="`lesson${index + 1}`"
              class="program__module--list-item"
            >
              <img
                src="/v2/ege/program/dot.svg"
                alt="dot"
              >
              <span>
                {{ item.name }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { egeModules, ogeModules } from './programs';

export default {
  name: 'EgeOgeProgram',
  data: () => ({
    activeTabs: [],
  }),

  computed: {
    subject() {
      const pageName = this.$route?.params?.subpage;

      if (this.$route.name === 'ege-subpage') {
        return egeModules[pageName] || null;
      }
      if (this.$route.name === 'oge-subpage') {
        return ogeModules[pageName] || null;
      }

      return null;
    },
    title() {
      return this.subject ? this.subject.title : null;
    },
    schedule() {
      return this.subject ? this.subject.schedule : null;
    },
    quantity() {
      const quantity = this.subject ? this.subject.quantity : null;
      if (quantity) {
        let number = quantity % 100;
        if (number >= 5 && number <= 20) {
          return `${quantity} занятий`;
        }
        number %= 10;
        if (number === 1) {
          return `${quantity} занятие`;
        }
        if (number >= 2 && number <= 4) {
          return `${quantity} занятия`;
        }
        return `${quantity} занятий`;
      }
      return null;
    },
    minutes() {
      return this.subject ? `>${this.subject.minutes} минут подготовки` : null;
    },
    modules() {
      return this.subject ? this.subject.modules : [];
    },
  },

  methods: {
    toggleTab(tab) {
      if (this.activeTabs.includes(tab)) {
        this.activeTabs = this.activeTabs.filter((item) => item !== tab);
      } else {
        this.activeTabs = [
          ...this.activeTabs,
          tab,
        ];
      }
    },
    getHeight(id) {
      if (process.browser) {
        // ждем отрисовки DOM
        const accBody = document.querySelector(`.program__module--list--${id}`)?.scrollHeight || 0;
        return `${accBody}px`;
      }

      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.program {
  &__title {
    font-size: 45px;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: -0.03em;
    color: $black-color;
    text-transform: uppercase;

    @include media-down(tablet) {
      font-size: 26px;
      line-height: 29px;
      letter-spacing: -0.02em;
    }
  }

  &__about {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    @include media-down(tablet) {
      margin-top: 24px;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 16px;
    }

    &--item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;

      @include media-down(tablet) {
        width: 100%;
        gap: 4px;
      }

      img {
        @include media-down(tablet) {
          width: 32px;
        }
      }

      span {
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        color: $black-color;

        @include media-down(tablet) {
          font-size: 14px;
          line-height: 14px;
        }
      }
    }
  }

  &__list {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    @include media-down(tablet) {
      margin-top: 24px;
      gap: 8px;
    }
  }

  &__module {
    position: relative;
    padding: 20px;

    border-radius: 20px;
    background-color: $white-color;
    box-shadow: 4px 4px 20px 0 rgba(#071539, .05);

    cursor: pointer;

    @include media-down(tablet) {
      padding: 16px;
    }

    &--icon {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &--quantity {
      font-size: 16px;
      font-weight: 700;
      line-height: 100%;
      color: $grey2;

      @include media-down(tablet) {
        font-size: 14px;
      }
    }

    &--name {
      width: 100%;
      max-width: 730px;
      margin-top: 10px;

      font-size: 35px;
      font-weight: 500;
      line-height: 100%;
      color: $black-color;

      @include media-down(tablet) {
        margin-top: 4px;

        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
      }
    }

    &--list {
      display: flex;
      flex-direction: column;
      gap: 12px;

      opacity: 0;
      pointer-events: none;
      transition: all .4s;

      @include media-down(talbet) {
        gap: 8px;
      }

      &-item {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
        letter-spacing: -0.01em;

        @include media-down(tablet) {
          font-size: 16px;
          font-weight: 400;
          line-height: 21px;
        }

        img {
          margin-top: 11px;
          margin-right: 8px;

          @include media-down(tablet) {
            margin-top: 7px;
          }
        }
      }
    }
    &--list.active {
      opacity: 1;
      pointer-events: auto;
    }
  }
}
</style>
